export const setFormInputValue = (key, value, form) => {
  return form.setFieldsValue({
    [key]: value,
  });
};
